export const webClientId = '1002887776253-lcpmome2v2pf556fc0f6fhf0afh7sk5j.apps.googleusercontent.com'